import withAPIAction from 'helpers/withAPIAction'
import {
  StockListReq,
  CreateStockReq,
  UpdateStockReq,
  DeleteStockReq,
  StockDetailReq,
  GrnHistoryListReq,
  GrnByProductListReq,
  ManageStockLogsReq,
  ManageOnlineStockReq,
  GrnProductsListReq,
  StockMoveMentReq,
  StockConfigDetailReq,
  UpdateStockConfigReq,
  DelteStockConfigReq,
  CountReq,
} from './types'
import {
  getStockListAction,
  createStockAction,
  updateStockAction,
  deleteStockAction,
  getStockDetailAction,
  getAllStockListAction,
  getGrnHistoryAction,
  getGrnListAction,
  getManageStockLogsAction,
  manageOnlineStockAction,
  getProductsGrnListAction,
  getStockMovementListAction,
  getStockConfigDetailAction,
  deleteConfigStockAction,
  updateConfigStockAction,
  getCountAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const stockListAPI = (data: StockListReq, token: string, xmid: string) => {
  return withAPIAction<StockListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.stockList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getStockListAction)
}

export const allStockListAPI = (data: StockListReq, token: string, xmid: string) => {
  return withAPIAction<StockListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.stockList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getAllStockListAction)
}

export const createStockAPI = (data: CreateStockReq, token: string, xmid: string) => {
  return withAPIAction<CreateStockReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateStock,
    data,
    token,
    xmid,
  })(createStockAction)
}

export const updateStockAPI = (data: UpdateStockReq, token: string, xmid: string) => {
  return withAPIAction<UpdateStockReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateStock,
    data,
    token,
    xmid,
  })(updateStockAction)
}

export const deleteStockAPI = (data: DeleteStockReq, token: string, xmid: string) => {
  return withAPIAction<DeleteStockReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateStock,
    data,
    token,
    xmid,
  })(deleteStockAction)
}

export const getStockDetailAPI = (data: StockDetailReq, token: string, xmid: string) => {
  return withAPIAction<StockDetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getStockByID,
    data,
    token,
    xmid,
  })(getStockDetailAction)
}

export const getGrnHistoryAPI = (data: GrnHistoryListReq, token: string, xmid: string) => {
  return withAPIAction<GrnHistoryListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.grnHistory,
    data,
    token,
    xmid,
  })(getGrnHistoryAction)
}

export const getProductGrnListAPI = (data: GrnByProductListReq, token: string, xmid: string) => {
  return withAPIAction<GrnByProductListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.productGrn,
    data,
    token,
    xmid,
  })(getGrnListAction)
}

export const getManageStockLogsAPI = (data: ManageStockLogsReq, token: string, xmid: string) => {
  return withAPIAction<ManageStockLogsReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: `${APIPath.manageStockLogs}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getManageStockLogsAction)
}

export const manageOnlineStockAPI = (data: ManageOnlineStockReq, token: string, xmid: string) => {
  return withAPIAction<ManageOnlineStockReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.manageOnlineStock,
    data,
    token,
    xmid,
  })(manageOnlineStockAction)
}

export const getProductsGrnListAPI = (data: GrnProductsListReq, token: string, xmid: string) => {
  return withAPIAction<GrnProductsListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.productsGrn,
    data,
    token,
    xmid,
  })(getProductsGrnListAction)
}

export const getStockMovementListAPI = (data: StockMoveMentReq, token: string, xmid: string) => {
  return withAPIAction<StockMoveMentReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.stockMovementReport}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getStockMovementListAction)
}

export const getStockConfigDetailAPI = (data: StockConfigDetailReq, token: string, xmid: string) => {
  return withAPIAction<StockConfigDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getDetailConfigStock,
    data,
    token,
    xmid,
  })(getStockConfigDetailAction)
}

export const updateConfigStockAPI = (data: UpdateStockConfigReq, token: string, xmid: any) => {
  return withAPIAction<UpdateStockConfigReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateConfigStock,
    data,
    token,
    xmid,
  })(updateConfigStockAction)
}

export const deleteConfigStockAPI = (data: DelteStockConfigReq, token: string, xmid: any) => {
  const endPoint = APIPath.deleteConfigStock.replace(':id', data.id.toString())
  return withAPIAction<DelteStockConfigReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteConfigStockAction)
}

export const getCountMinimumStockAPI = (data: CountReq, token: string, xmid: any) => {
  return withAPIAction<CountReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.countMinimumStock}`,
    data,
    token,
    xmid,
  })(getCountAction)
}
